import { useState } from "react";
import CheckComponent from "../../../../../shared/components/checkComponent";
import useAppStateStore from "../../../../../shared/store/AppStateStore";
import SupportStep from "../../../enums/SupportStep";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import { scrollToTop } from "../../../../../shared/utils/scrollUtils";
import PortalBackButton from "../../../components/PortalBackButton";
import useSupportStore from "../../../store/supportStore";
import { updateSupportType } from "../../../utils/supportNavUtils";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";
import Button from "../../../../../shared/components/Button";

const stepOptions = [
  { id: SupportStep.SP_ADDRESS, title: "Address" },
  { id: SupportStep.SP_VEHICLE, title: "Vehicle" },
  { id: SupportStep.SP_LICENSE, title: "Licensing Authority" },
  { id: SupportStep.SP_REGISTRATION, title: "Registration" },
  { id: SupportStep.SP_USE, title: "Use" },
  { id: SupportStep.SP_CANCELLATION, title: "Cancellation" },
  { id: SupportStep.SP_OTHER, title: "Other" },
];

const CANCELLATION_ID = SupportStep.SP_CANCELLATION;

const Sp1 = () => {
  const [error, setError] = useState("");
  let STATE = useAppStateStore();
  const store = useSupportStore.getState();

  const selectedSteps = Array.isArray(STATE.selectedOptions)
    ? STATE.selectedOptions
    : [];

  const isCancellationSelected = selectedSteps.some(
    (step) => step.id === CANCELLATION_ID,
  );
  const isInvalidCombo = isCancellationSelected && selectedSteps.length > 1;

  const handleCheckboxChange = (id, title) => {
    const prev = Array.isArray(STATE.selectedOptions)
      ? STATE.selectedOptions
      : [];
    const exists = prev.find((step) => step.id === id);
    let newSteps;
    if (exists) {
      newSteps = prev.filter((step) => step.id !== id);
    } else {
      newSteps = [...prev, { id, title }];
    }
    // Prevent selecting anything else with cancellation
    if (
      (id === CANCELLATION_ID && !exists && prev.length > 0) ||
      (id !== CANCELLATION_ID &&
        prev.some((step) => step.id === CANCELLATION_ID))
    ) {
      setError("You cannot select anything else with cancellation.");
      return;
    }
    setError("");
    STATE.setSelectedOptions(newSteps);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (selectedSteps.length < 1) {
      setError("Please select at least one option before proceeding.");
      return;
    }
    if (isInvalidCombo) {
      setError("You cannot select anything else with cancellation.");
      return;
    }
    setError("");
    STATE.setSpCurrentStep(selectedSteps[0].id);
    updateSupportType();
    scrollToTop();
  };

  return (
    <>
      <QuoteFormWrapper>
        <form onSubmit={onSubmit}>
          <QuoteStepHeading
            title="Make a change to your policy"
            description="Complete the below form to get a quote to change or cancel your policy. Once you have entered the information you will receive a quote via email and SMS."
          />
          <h2 className="tw-m-0 tw-mb-6 tw-text-lg tw-font-bold tw-text-dis-navy sm:tw-text-xl">
            Which of the following do you want to change?
          </h2>
          <div className="tw-mb-[30px] tw-grid tw-grid-cols-1 tw-gap-[10px] md:tw-gap-[15px] sm:tw-grid-cols-2">
            {stepOptions.map(({ id, title }) => (
              <CheckComponent
                key={id}
                title={title}
                id={id}
                checked={selectedSteps.some((step) => step.id === id)}
                onChange={() => handleCheckboxChange(id, title)}
              />
            ))}
          </div>
          <p className="tw-mb-3 tw-mt-3 tw-text-base tw-leading-[1.5] tw-text-dis-text-2">
            To make more than one change, select all that apply, then select Get
            started
          </p>
          {error && (
            <div role="alert" className="tw-mt-2 tw-text-sm tw-text-dis-error">
              {error}
            </div>
          )}
          <Button
            type="submit"
            className="tw-mt-4"
            fullWidth
            aria-disabled={selectedSteps.length < 1 || isInvalidCombo}
            variant={
              selectedSteps.length < 1 || isInvalidCombo ? "disabled" : "main"
            }
          >
            Get Started
          </Button>
        </form>
      </QuoteFormWrapper>
      <PortalBackButton />
    </>
  );
};

export default Sp1;
